import { useReadTenantQuery } from '@/shared/redux/api/ident/ident-api';

export const useFeatureFlag = () => {
  const { data } = useReadTenantQuery();
  const featureFlags = data?.readTenant.featureFlags;

  const isFeatureEnabled = (featureName: string): boolean => {
    const flag = featureFlags?.find(
      (featureFlag) => featureFlag.featureName === featureName,
    );

    return Boolean(flag?.isEnabled);
  };

  return {
    isFeatureEnabled,
  };
};
